/**
 * TanStack Query Client Configuration
 * Manages server state caching and refetching behavior
 */
import { QueryClient } from '@tanstack/react-query'

/**
 * Query client with optimized settings for recruitment application
 *
 * Configuration:
 * - staleTime: 5 minutes - Job postings don't change frequently
 * - retry: 3 attempts with exponential backoff
 * - refetchOnWindowFocus: false - Prevent unnecessary refetches when user switches tabs
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 3,
      refetchOnWindowFocus: false,
    },
  },
})
